import { Button, TextField, Box, Typography } from '@material-ui/core'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import api from '../../api/client';
import { logoSrc, uploadLogo } from '../../api/logoSrc'
import React, { useState } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { toEnglishDigits } from '../../assets/utils'
import { toast } from '../../api/toast'
import { departmentsState } from '../../pages/admin/atoms'
import { loadingState } from '../../recoil/atoms'

const EditDepartment = props => {
    const [departments, setDepartments] = useRecoilState(departmentsState)
    const currentDepartment = departments.filter(d => d.id === props.id)[0]
    const setLoading = useSetRecoilState(loadingState)


    const [username, setUsername] = useState(currentDepartment.username)
    const [password, setPassword] = useState('')
    const [name, setName] = useState(currentDepartment.name)
    const [shortName, setShortName] = useState(currentDepartment.short_name || '')
    const [nationalCode, setNationalCode] = useState(currentDepartment.national_code)
    const [logoBusy, setLogoBusy] = useState(false)
    const [logoMsg, setLogoMsg] = useState('')
    const [logoOk, setLogoOk] = useState(false)

    const handleLogoFile = async (e) => {
        const file = e.target.files && e.target.files[0]
        if (!file) return
        setLogoBusy(true)
        setLogoMsg('')
        try {
            const newLogo = await uploadLogo(file, { department_id: props.id })
            setDepartments(departments.map(d => d.id === props.id ? { ...d, logo: newLogo } : d))
            setLogoMsg('لوگوی سازمان ثبت شد ✓')
            setLogoOk(true)
        } catch (err) {
            setLogoMsg((err.response && err.response.data && err.response.data.detail) || 'خطا در ارسال تصویر')
            setLogoOk(false)
        } finally {
            setLogoBusy(false)
            e.target.value = ''
        }
    }

    const updateHandler = () => {
        setLoading(true)
        api.put('users/departments/' + props.id + '/', {
            username: toEnglishDigits(username),
            password: toEnglishDigits(password),
            name: toEnglishDigits(name),
            short_name: shortName,
            national_code: toEnglishDigits(nationalCode)
        }).then(response => {
            if (response.status === 200) {
                setDepartments(departments.map(d => d.id === props.id ? { ...d, username: username, name: name, short_name: shortName, national_code: nationalCode } : d))
                props.setOpenEditDepartment(-1)
            } else {
                toast('خطا در ذخیره اطلاعات')
            }
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            toast((err.response && err.response.data && (err.response.data.detail || err.response.data.username || err.response.data.national_code)) || 'خطا در ذخیره اطلاعات')
        })
    }

    return (
        <>
            <TextField
                margin='normal'
                label="نام کاربری"
                variant='outlined'
                fullWidth
                dir='ltr'
                autoComplete={false}
                value={username}
                onChange={event => setUsername(event.target.value)}
            />
            <TextField
                margin='normal'
                label="کلمه عبور"
                variant='outlined'
                fullWidth
                autoComplete={false}
                type='password'
                dir='ltr'
                value={password}
                onChange={event => setPassword(event.target.value)}
            />
            <TextField
                margin='normal'
                label="عنوان"
                variant='outlined'
                fullWidth
                value={name}
                autoComplete={false}
                onChange={event => setName(event.target.value)}
            />
            <TextField
                margin='normal'
                label="نام اختصاری"
                helperText="مثلاً «راهداری» — در جدولها کنار نام کامل نمایش داده می‌شود"
                variant='outlined'
                fullWidth
                value={shortName}
                autoComplete={false}
                onChange={event => setShortName(event.target.value)}
            />

            {/* ثبت لوگوی سازمان — فایل یا عکس با دوربین موبایل */}
            <Box display="flex" alignItems="center" gap={2} style={{ marginTop: 12, marginBottom: 8 }}>
                <Box style={{ width: 56, height: 56, borderRadius: '50%', overflow: 'hidden', background: '#e8eafd', flexShrink: 0, border: '2px solid #fff', boxShadow: '0 2px 8px rgba(20,30,80,.12)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {currentDepartment.logo ? (
                        <img
                            src={logoSrc(currentDepartment.logo)}
                            alt=""
                            style={{ width: 56, height: 56, objectFit: 'cover' }}
                            onError={(e) => { e.target.style.display = 'none' }}
                        />
                    ) : (
                        <Typography style={{ fontWeight: 800, color: '#1a237e', fontSize: 11 }}>بدون لوگو</Typography>
                    )}
                </Box>
                <Button
                    component="label"
                    variant="outlined"
                    color="primary"
                    disabled={logoBusy}
                    startIcon={<PhotoCameraIcon />}
                >
                    {logoBusy ? 'در حال ارسال...' : 'ثبت لوگو (فایل یا عکس موبایل)'}
                    <input hidden type="file" accept="image/*" capture="environment" onChange={handleLogoFile} />
                </Button>
            </Box>
            {logoMsg && (
                <Typography variant="body2" style={{ color: logoOk ? '#2e7d32' : '#c62828', fontWeight: 700 }}>
                    {logoMsg}
                </Typography>
            )}
            <TextField
                margin='normal'
                id="username"
                label="شناسه ملی"
                variant='outlined'
                autoComplete={false}
                fullWidth
                value={nationalCode}
                onChange={event => setNationalCode(event.target.value)}
            />
            <Button
                variant='contained'
                color='primary'
                onClick={() => updateHandler()}
            >
                ذخیره
            </Button>
            <Button
                variant='contained'
                color='primary'
                style={{ marginRight: '10px' }}
                onClick={() => props.setOpenEditDepartment(-1)}
            >
                انصراف
            </Button>
        </>
    )
}

export default EditDepartment